module.exports = __webpack_public_path__ + "img/5.60621665.png";